// extracted by mini-css-extract-plugin
export default {"scrollLayout":"a4U0MC","scrollLayoutContent":"b4U0MC","layout":"c4U0MC","layoutContent":"d4U0MC"};